<!--文件名称-->
<template>
  <div class="warp">
    <!-- logo -->
    <div class="logo">
      <img @click.stop="skipPage(0)" src="../../assets/iphone/logo.png" />
    </div>
    <!-- 搜索框 -->
    <div class="search">
      <div class="icon" @click="shwoSearch"><img src="../../assets/iphone/icon01.png" /></div>
      <div class="box" v-if="isSearch">
        <div class="box_bg">
          <input type="text" v-model="keyword" @keyup.enter="tosearch" placeholder="请输入关键词">
          <div class="btns" @click="tosearch"><img src="../../assets/iphone/icon06.png" /></div>
        </div>
      </div>
      <div class="beijing" v-if="isSearch" @click="hideBeijing"></div>
    </div>
    <!-- 导航栏 -->
    <div class="wc_nav">
      <div class="icon" @click="showOrHideNav">
        <img v-if="!showNav" src="../../assets/iphone/icon02.png" />
        <img v-if="showNav" src="../../assets/iphone/icon03.png" />
      </div>
      <div class="nav_box" v-if="showNav">
        <div class="ul">
          <div class="li" :class="active == '-1' && 'nav-active'">
            <div class="a1" @click.stop="clickNav(0)">
              <span class="title">首页</span>
            </div>
          </div>
          <div class="li" v-for="(item, index) of tree" :key="index">
            <div class="a1" @click.stop="isShow(item.scode)">
              <span class="title">{{ item.name }}</span>
              <img v-if="idx == item.scode" src="../../assets/iphone/icon04.png" class="more">
              <img v-else src="../../assets/iphone/icon05.png" class="more">
            </div>
            <div class="subnav" v-if="item.subs" v-show="idx == item.scode">
              <span v-for="(value, key) of item.subs" :key="key" @click.stop="clickNav(value)">{{
                value.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="beijing" v-if="showNav" @click="hideBeijing"></div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["skipPage"],
  data() {
    return {
      xd_flag: false,
      isSearch: false,
      keyword: "",
      showNav: false,
      idx: -1,
    };
  },

  computed: {
    //所有菜单
    tree() {
      return this.$store.state.user.tree;
    },
    //主菜单选中
    active() {
      return this.$store.state.user.active;
    },
    //侧边栏选中
    subActive() {
      return this.$store.state.user.subActive;
    },

    //侧边栏菜单
    subTree() {
      return this.$store.state.user.subTree;
    },

  },

  mounted() {

  },
  methods: {

    shwoSearch() {
      this.isSearch = !this.isSearch;
      this.showNav = false

      if (this.isSearch) {
        document.body.style.overflow = 'hidden';
        this.$emit("hideSubNav")
      } else {
        document.body.style.overflow = '';
      }
    },

    //显示隐藏导航
    showOrHideNav() {
      this.showNav = !this.showNav

      this.isSearch = false
      if (this.showNav) {
        this.$emit("hideSubNav")
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }

    },

    hideBeijing() {
      this.showNav = false
      this.isSearch = false
      document.body.style.overflow = '';
    },

    clickNav(item) {
      this.showNav = false;
      this.isSearch = false;
      this.skipPage(item)
    },

    isShow(id) {

      // 如果用户点击的时候，当前判断展开的标识idx,是-1，的时候，那说明，用户要展开，那么就把id赋给idx ,标识，这样用户就展开了
      if (this.idx == -1) {
        this.idx = id;
      } else if (this.idx == id) {//如果用户点击的id 和上次点击的id一样的时候，那就说明，用户点击的是上一次点击展开变成收起的按钮那行
        this.idx = -1;
      } else {//如果用户点击的id和标识idx不相等，那么说明用户点击了其他想要展开的行
        this.idx = id;
      }

      // 简化
      // if(this.idx == id){
      // 	this.idx = -1;
      // }else{
      // 	this.idx = id;
      // }
    },



    //搜索
    tosearch() {
      let vm = this;
      this.$router.push({
        path: "/search",
        query: {
          keyword: vm.keyword,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.warp {
  padding: .25rem 0 .25rem .2rem;
  background-color: #fff;
  display: flex;
  align-items: center;

  .logo {
    flex: 1;

    img {
      width: 2.2rem;
      height: .8rem;
    }
  }

  .search {


    .icon {
      padding: .2rem;

      img {
        width: .4rem;
      }
    }

    .box {
      position: absolute;
      width: 100vw;
      right: 0;
      top: 1.3rem;
      background-color: rgba(181, 1, 4, .7);
      padding: .2rem .17rem;
      z-index: 200;

      .box_bg {
        background-color: #fff;
        border-radius: .76rem;
        overflow: hidden;
        height: .76rem;
        display: flex;
        // align-items: center;

        input {
          font-size: .24rem;
          padding: 0 .4rem;
          border: 0 none;
          flex: 1;
          outline: none;
          line-height: .76rem;
        }

        .btns {
          width: .5rem;
          height: .5rem;
          background-color: rgba(181, 1, 4, .8);
          overflow: hidden;
          border-radius: .3rem;
          box-sizing: border-box;
          margin: .13rem;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: .3rem;
            height: .3rem;
          }
        }
      }
    }
  }



  .wc_nav {
    .icon {
      padding: .2rem;

      img {
        width: .4rem;
      }
    }

    .nav_box {
      position: absolute;
      right: 0;
      top: 1.3rem;
      z-index: 200;

      .ul {
        list-style: none;

        .li {
          width: 2.55rem;

          background-color: rgba(181, 1, 4, .8);


          .a1 {
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(255, 255, 255, .5);
            padding: 0 .15rem 0 .25rem;
            line-height: .95rem;

            span {
              flex: 1;
              font-size: .28rem;
              color: #fff;
            }

            img {
              width: .3rem;
            }
          }

          .subnav {
            padding: .1rem 0;
            border-bottom: 1px solid rgba(255, 255, 255, .5);

            span {
              padding: 0 .15rem 0 .25rem;
              display: block;
              line-height: .8rem;
              color: #fff;
              font-size: .26rem;
            }
          }
        }
      }
    }
  }

  .beijing {
    position: absolute;
    top: 1.3rem;
    left: 0;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, .4);
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iphone/Header.vue